export const utilizationPctToRatio = (value: number | null | undefined): number | null => {
  if (!Number.isFinite(value)) return null;
  const pct = value as number;
  if (pct < 0) return null;
  return pct / 100;
};
